import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  stars: 5,
  quote: 'Empecé a leerlo pensando que sería más de lo mismo. En el capítulo 3 ya había escrito más de una página de notas. Esa semana tuve la primera conversación real con mi hija de 14 años en meses.',
  author: 'María T.',
  role: 'Mamá de una adolescente de 14 años',
  avatarImg: 'https://cdn.magicpatterns.com/uploads/srQPkEjW2ez1WMkN7c3fDD/baja_1.png'
}, {
  stars: 5,
  quote: 'Como padre, siempre sentí que no había libros para mí. Este sí. Práctico, sin rodeos, sin sermones. Entendí por qué mi hijo reaccionaba así y dejé de tomarlo personal.',
  author: 'Carlos R.',
  role: 'Papá de dos adolescentes, 13 y 16 años',
  avatarImg: 'https://cdn.magicpatterns.com/uploads/8auDKM8Yys7TA4yMkfWPHt/baja2.png'
}, {
  stars: 5,
  quote: 'Los ejercicios al final de cada capítulo son lo mejor. No es solo teoría te obliga a mirarte a ti mismo. Descubrí patrones de mi propia infancia que estaba repitiendo sin darme cuenta.',
  author: 'Luisa M.',
  role: 'Mamá de un adolescente de 12 años',
  avatarImg: 'https://cdn.magicpatterns.com/uploads/teB3U1zEEk7pJobAkAz9mM/Baja3.png'
}];
export function TestimonialsSection() {
  return <section className="py-20 px-5 bg-[#F7F9FF] text-center" data-id="element-164">
      <div className="max-w-5xl mx-auto" data-id="element-165">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-4xl text-[#1A2744] mb-12" data-id="element-166">
          Lo Que Dicen los Padres que Ya lo Leyeron
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-167">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-3xl p-8 text-left shadow-[0_4px_20px_rgba(0,0,0,0.06)]" data-id="element-168">
              <div className="text-[#F4A535] text-lg mb-4 tracking-wider" data-id="element-169">
                {'★'.repeat(testimonial.stars)}
              </div>
              <blockquote className="text-base text-[#4A5568] italic leading-relaxed mb-5" data-id="element-170">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex items-center gap-3" data-id="element-171">
                {'avatarImg' in testimonial && testimonial.avatarImg ? <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0" data-id="element-172">
                    <img src={testimonial.avatarImg} alt={testimonial.author} className="w-full h-full object-cover" data-id="element-173" />
                  </div> : <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#1A2744] to-[#2D5A7A] flex items-center justify-center text-lg flex-shrink-0" data-id="element-174">
                    {testimonial.avatar}
                  </div>}
                <div data-id="element-175">
                  <strong className="block text-sm text-[#1A2744]" data-id="element-176">
                    {testimonial.author}
                  </strong>
                  <span className="text-xs text-[#A0AEC0]" data-id="element-177">
                    {testimonial.role}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}